const initialState = {
    data: null,
    isLoading: false,
    error: '',
    isUpdateLoading: false,
    isUpdated: false,
    isUpdatedError: '',
  };
  
  const AlertSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
      case "ALERT_SETTINGS_LOADING":
        return {
          ...state,
          isLoading: true,
          data: null,
          error: '',
        };
      case "ALERT_SETTINGS_SUCCESS":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
          error: '',
        };
      case "ALERT_SETTINGS_ERROR":
        return {
          ...state,
          isLoading: false,
          data: null,
          error: action.payload,
          isUpdated: false,
        };
      case 'ALERT_SETTINGS_UPDATE_LOADING':
        return {
          ...state,
          isUpdateLoading: true,
          isUpdated: false,
          isUpdatedError: '',
        };
      case 'ALERT_SETTINGS_UPDATE_SUCCESS':
        return {
          ...state,
          isUpdateLoading: false,
          isUpdated: true,
          isUpdatedError: '',
        };
      case 'ALERT_SETTINGS_UPDATE_ERROR':
        return {
          ...state,
          isUpdated: false,
          isUpdateLoading: false,
          isUpdatedError: action.payload,
        };
      case 'RESET_ALERT_SETTINGS_UPDATE':
        return {
          ...state,
          isUpdated: false,
          isUpdatedError: '',
        };
      default:
        return state;
    }
  };
  
  export default AlertSettingsReducer;